<template>
  <div class="flex flex-col">
    <div class="overflow-x-auto">
      <div class="inline-block min-w-full py-2 align-middle">
        <div class="overflow-hidden border-b border-ontick-steel-300 shadow dark:border-ontick-steel-500 sm:rounded-lg">
          <table class="min-w-full divide-y divide-ontick-steel-300 dark:divide-ontick-steel-500">
            <thead class="bg-ontick-steel-100 dark:bg-ontick-steel-500 sticky top-0">
              <tr>
                <th
                  v-for="(item, index) in header"
                  :key="index"
                  scope="col"
                  class="px-6 py-3 text-center text-sm font-medium uppercase tracking-wider text-ontick-steel-900 dark:text-gray-300"
                >
                  {{ item }}
                </th>
                <th
                  class="px-6 py-3 text-left text-sm font-medium uppercase tracking-wider text-ontick-steel-900 dark:text-gray-300"
                >
                  Descrição
                </th>
              </tr>
            </thead>

            <tbody
              class="divide-y divide-ontick-steel-300 bg-gray-50 dark:divide-ontick-steel-600 dark:bg-ontick-graphite-500"
            >
              <tr
                v-show="logs"
                v-for="(item, index) in logs"
                :key="index"
                class="dark:bg-ontick-graphite-500 bg-gray-50"
              >
                <td class="td-items text-ontick-blue-500 text-center">
                  {{ item.log_datetime | moment("DD/MM/YYYY HH:mm:ss:SSS") }}
                </td>
                <td
                  :class="
                    item.log_type == 'ERROR'
                      ? 'text-ontick-red-500'
                      : item.log_type == 'INFO'
                        ? 'text-ontick-blue-500'
                        : 'text-ontick-steel-900 dark:text-gray-300'
                  "
                  class="td-items flex justify-center"
                >
                  <span :content="item.log_type" v-tippy="{ arrow: true, theme: 'green' }">
                    <span v-html="icons[item.log_type.toLowerCase()]"></span>
                  </span>
                </td>
                <td class="td-items text-ontick-steel-900 dark:text-gray-300 border-2 w-full max-w-0">
                  <expandable-text-line :use-click="useClick" class="w-full block">
                    {{ item.log_msg }}
                  </expandable-text-line>
                </td>
              </tr>
              <tr v-if="logs.length == 0">
                <td class="py-6" colspan="3">
                  <h2 class="text-center text-lg font-medium text-ontick-steel-900 dark:text-gray-300">
                    Nenhum log para exibir
                  </h2>
                </td>
              </tr>
              <tr class="bg-ontick-steel-100 dark:bg-ontick-graphite-500">
                <td colspan="3">
                  <div class="flex justify-center">
                    <button @click="viewMore()" v-show="!limit_logs" class="mx-auto py-3 uppercase">
                      <div class="flex items-center">
                        <span class="text-ontick-blue-500" v-html="!submitted ? $icons.plus : $icons.loading"></span>
                        <p class="ml-3 font-semibold text-ontick-steel-900 dark:text-gray-300">Ver mais</p>
                      </div>
                    </button>
                    <div class="py-3 text-center" v-if="logs_msg == 'nenhuma ordem encontrada'">
                      <h1 class="text-xl font-semibold text-white">Sem dados para exibir</h1>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ExpandableTextLine from "vue-expandable-text-line";
import placeholderTable from "@/app/shared/components/placeholder/placeholder-table.component";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    ExpandableTextLine,
    placeholderTable,
  },

  data() {
    return {
      useClick: true,
      submitted: false,
      header: ["Data", "Tipo"],
      icons: {
        debug: `<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path></svg>`,
        warning: `<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path></svg>`,
        error: `<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>`,
        info: `<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>`,
        critical: `<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.618 5.984A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016zM12 9v2m0 4h.01"></path></svg>`,
      },
    };
  },

  created() {
    this.logsStrategies();
  },

  methods: {
    ...mapActions({
      logsStrategies: "performance/logsStrategies",
      destroyLogs: "performance/destroyLogs",
    }),

    viewMore() {
      let index_id = this.logs.length - 1;
      let log_id = this.logs[index_id].log_id;
      this.submitted = true;

      this.logsStrategies(log_id)
        .then(() => {
          this.submitted = false;
        })
        .catch(() => {
          this.submitted = false;
        });
    },
  },

  computed: {
    ...mapState({
      logs: (state) => state.performance.logs,
      investment: (state) => state.performance.investment,
      limit_logs: (state) => state.performance.limit_logs,
      logs_msg: (state) => state.performance.logs_msg,
    }),
  },
  watch: {
    investment: {
      deep: true,
      handler(value) {
        this.destroyLogs();
        this.logsStrategies();
        return value;
      },
    },
  },

  unmounted() {
    this.destroyLogs();
  },
};
</script>

<style lang="scss" scoped>
.td-items {
  @apply whitespace-nowrap px-3 py-2 text-xs;
}
</style>
